export const errorMessage = {
  timeout: '请求超时，请稍后重试',
  serverError: '系统繁忙，请稍后再试',
};

export const interfaceConfig = {
  default: {
    timeout: 30000,
    isShowLoading: false, // 是否需要显示loading遮罩
    loadingShow: '正在加载中...', // 显示loading遮罩的显示内容
    requestMethod: 'POST',
    isResolveError: false, // 是否将服务端的错误当成resolve丢给外面 结构为 { errCode:'10001', errMsg:'错误信息...'}
    isShowNetErr: true,
    showServerErr: true, // 默认展示服务端错误
  },
};
